export default __webpack_public_path__ + "static/media/StepTwo.af04bfea.svg";